export default __webpack_public_path__ + "static/media/lan-dude.a80bdd15.svg";